import { render, staticRenderFns } from "./TransformsMismatch.vue?vue&type=template&id=4f891a2f&"
import script from "./TransformsMismatch.vue?vue&type=script&lang=js&"
export * from "./TransformsMismatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports